import React from 'react';
import { flag } from '../../../hooks/utils';
import  styles from  './country-flag.module.scss'; // import CSS file with animation styles

const  CountryFlag= ({country, iso2}) => {
    return (
      <span className={styles.countryFlag}>
          <img src={flag(iso2)} alt={country} />
          <span>{country}</span>
      </span>
    )

}

export default CountryFlag;
